import React from 'react';
import { Link } from 'react-router-dom';
import { Icons } from '../../../utils/icons';

const Breadcrumb = ({ items = [] }) => {
    return (
        <div className="flex gap-1 items-center h-12 text-cs text-theme">
            {/* Home Icon */}
            <Link to="/" className="bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6] p-2 rounded-full text-white ">
                {Icons.HOME}
            </Link>

            {items.filter(item => item.label).map((item, index) => (
                <React.Fragment key={index}>

                    <span className="text-theme ">{Icons.RIGHTARROW}</span>

                    {item.path ? (
                        <Link
                            to={item.path}
                            className={`${
                                index === items.length - 1
                                    ? 'text-textLight font-medium'
                                    : 'text-theme font-semibold hover:text-themeHover'
                            }`}
                        >
                            {item.label}
                        </Link>
                    ) : (
                        <span
                            className={`${
                                index === items.length - 1
                                    ? 'text-textLight font-light'
                                    : 'text-theme font-semibold underline-offset-[6px] !decoration-theme'
                            }`}
                        >
                            {item.label}
                        </span>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default Breadcrumb;
